/**
 * COMPONENTE NEWS WITH SIDEBAR
 * =============================
 * Muestra noticias con un sidebar de clima y cotizaciones
 * Ahora obtiene los datos del backend
 * 
 * Refactorizado en sub-componentes:
 * - NewsList: Lista de noticias
 * - Sidebar: Contiene CotizacionesWidget y WeatherWidget
 */

import React, { useState, useEffect } from 'react';
import { api } from '../../services/api';
import { NewsList, Sidebar } from './news-sidebar';

const NewsWithSidebar = () => {
  const [newsData, setNewsData] = useState([]);
  const [weatherData, setWeatherData] = useState(null);
  const [cotizacionesData, setCotizacionesData] = useState(null);
  const [loading, setLoading] = useState(true);

  // Cargar datos del backend
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [news, weather, cotizaciones] = await Promise.all([
          api.getNews(3),  // Solo 3 noticias para el home
          api.getWeather(),
          api.getCotizacionesClaim()
        ]);
        setNewsData(news);
        setWeatherData(weather);
        setCotizacionesData(cotizaciones);
      } catch (error) {
        console.error('Error loading data:', error);
        setNewsData([]);
        setWeatherData(null);
        setCotizacionesData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <section id="noticias" className="py-16 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid lg:grid-cols-3 gap-8">
          {/* Left - Noticias */}
          <NewsList newsData={newsData} />

          {/* Right Sidebar - Cotizaciones y Clima */}
          <Sidebar
            cotizacionesData={cotizacionesData}
            weatherData={weatherData}
          />
        </div>
      </div>
    </section>
  );
};

export default NewsWithSidebar;